import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Typography } from "antd";
import moment from "moment";
import { CustomDatePicker } from "../customComponent/CustomDatePicker";

const { Text } = Typography;

const DueDateFormItemComponent = ({
  t,
  style,
  title,
  required = true,
  editable = true,
  showLabel = false,
  strong = false,
  defaultValue
}) => (
  <Form.Item
    name="dueDate"
    label={
      showLabel ? (
        <Text strong={strong} style={{ color: "#9B9B9B" }}>
          {title ? title : t("form.due_date.label")}
        </Text>
      ) : null
    }
    style={style}
    colon={false}
    rules={[{ required, message: t("form.due_date.error_required") }]}
  >
    {editable ? (
      <CustomDatePicker
        placeholder={t("form.due_date.placeholder")}
        disabled={!editable}
        format={"MM/DD/YYYY"}
        allowClear={false}
      />
    ) : (
      <Text>{defaultValue ? `${moment(defaultValue).format("MM/DD/YYYY")}` : "-"}</Text>
    )}
  </Form.Item>
);

const DueDateFormItem = withTranslation()(DueDateFormItemComponent);

export { DueDateFormItem };
